"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('scriptLoaders/bundleLoader',["require", "exports", "jquery", "context"], function (require, exports, jquery, context) {
    "use strict";

    var BundleLoader = function () {
        function BundleLoader() {
            _classCallCheck(this, BundleLoader);

            this.loadBundleAsyncOnce = function () {
                if (typeof this.loadBundleDeferred === 'undefined' || this.loadBundleDeferred.state() === 'rejected') {
                    this.loadBundleDeferred = jquery.Deferred();
                    if (context.appBundleUrl != '') {
                        var script = document.createElement('script');
                        script.setAttribute('type', 'text/javascript');
                        script.setAttribute('src', context.appBundleUrl);
                        script.onload = this.loadSuccess.bind(this);
                        document.body.appendChild(script);
                    } else {
                        this.loadSuccess();
                    }
                }
                return this.loadBundleDeferred.promise();
            };
            this.loadFail = function () {
                this.loadBundleDeferred.reject();
            };
        }

        _createClass(BundleLoader, [{
            key: "loadSuccess",
            value: function loadSuccess() {
                this.loadBundleDeferred.resolve();
            }
        }]);

        return BundleLoader;
    }();

    return new BundleLoader();
});
//# sourceMappingURL=bundleLoader.js.map;
